import React from "react";

export default function AboutPage() {
  return (
    <div className="section">
      <h3 className="title is-3">關於我們</h3>
      <div className="columns is-centered">
        <div className="column-narrow is-half">
          <div className="content is-medium">
            <div className="section has-text-left">
              <h4 className="title is-4 has-text-centered">
                「價值教育──老師培訓計劃」簡介
              </h4>
              <p>
                國際經濟合作發展組織（Organization for Economic Co-operation and
                Development, OECD）於2019年推出2030教育學習指南（Learning
                Compass
                2030），指出根據學生的需求，除了學習知識和技能外，教育亦應重視態度和價值觀，使學生能充份發揮潛能，以促進個人、社會及世界的福祉。由此可見，教育不應只偏重學術方面，態度和價值觀也是未來的學習重點。
              </p>
              <p>
                以往不少的價值教育項目對象多以學生為主，而忽略了老師的培訓。本會是次獲優質教育基金贊助，於2020年10月至2022年9月期間，推展一項《價值教育──老師培訓計劃》，期望透過是項計劃為本港中、小學的前線老師進行有關價值教育的培訓。
              </p>
              <p>
                本項目主要培育老師建立個人氣質及健康有序的人生觀，從而能以身作則，以德育人，培育學生正面價值觀和態度。本計劃的價值內容及根據現行教育課程指引中所提及的價值觀和態度，以及美國著名心理學家Martin
                Seligman等歸納出來的正向教育24種人格中，嚴選出10個價值主題。主題涵蓋由內至外的價值發展面向，內在的有：仁愛待人、彼此尊重、獨立思考、慎思明辨、身份認同；外在的有：善用自由、公道不偏、承擔責任、守法護法、和平友愛。
              </p>
              <p>
                以往老師在製作教材時多以校本為主，欠缺學校之間的交流。通過是項計劃，我們會為老師舉辦有關價值教育的講座，讓老師透徹地了解各價值項目的內涵；亦會舉辦工作坊，分享如何剪裁教材及應用教案。此外，在老師施教時，我們更會派出專家到校支援，協助老師修訂及改善教材，優化整個教學過程。參與的中、小學老師更可藉着檢討會、總結會等機會互相交流，各取所長，從而發揮協同作用，製作多套切合不同校情的教材。計劃完結後，本會會把教材整理成冊，製作成中、小學各10套教材，供全港學校使用。
              </p>
              <p>
                是項計劃的先導期（10/2020 -
                9/2021）參與學校數量為中、小學各5間；執行期（10/2021 -
                6/2022）參與學校數量為中、小學各20間，歡迎有趣興參與是項計劃的學校及老師與本會聯絡，讓我們攜手協作，共同為本港中、小學生的價值教育發展盡一分力。
              </p>
            </div>
          </div>
        </div>
        <div className="column is-half">
          <div className="content is-medium">
            <div className="section has-text-left">
              <h4 className="title is-4 has-text-centered">教育評議會簡介</h4>
              <p>
                教育評議會（教評會）於九四年十月成立，是由一群熱心教育工作、緊守教育崗位、關注教育事務、有志影響教育政策的教育工作者所組成。作為一個教育專業團體，教評會致力於以下三個範疇的工作：
                <ol>
                  <li>專題研究；</li>
                  <li>政策評論；</li>
                  <li>經驗推廣。</li>
                </ol>
              </p>
              <p>
                教評會認為香港特區的教育，應主要由專業教育人員領導及參與，以進行研究、設計及發展。教評會願以積極、正面、理性、專業的態度和立場推動教育改革，提高教育質素。
              </p>
              <p>
                教評會會員包括大專講師，中學、小學、特殊學校及幼兒教育的校長和教師等。為推動會務，在執委會之下分設多個專題小組，如課程、學生行為、學校行政、教師專業、小學教育等。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
